import { css } from "@emotion/react";
import type { ImmutableObject } from "@/lib/immutable";
import type { Product } from "../../../hooks/useInventoryState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";
import { Badge } from "../../ui/badge";

// ListView - Barcodes
export type ProductBrowserListItemBarcodesProps = {
	product: ImmutableObject<Product>;
};
export const ProductBrowserListItemBarcodes: React.FC<
	ProductBrowserListItemBarcodesProps
> = (props) => {
	const product = props.product;
	const translate = useTranslate();

	return (
		<>
			{product.Barcodes && (
				<div className="field">
					<div className="caption">{translate("Barcodes")}:</div>
					<div className="value">
						{product.Barcodes?.split(",").map((tag) => (
							<span key={tag}>
								{tag && (
									<Badge variant="outline" css={css`margin: .25em;`}>
										{tag}
									</Badge>
								)}
							</span>
						))}
					</div>
				</div>
			)}
		</>
	);
};
